import React from "react";
import { Link } from "react-router-dom";
import { useLanguageContext } from "../context/LanguageContext";

const BigBoardMocksPage: React.FC = () => {
  const { isHE } = useLanguageContext();

  const cardClass =
    "group relative flex flex-col rounded-2xl border border-white/10 bg-[#191C22] p-5 shadow-elevation ring-1 ring-white/5";

  return (
    <div className="min-h-screen bg-terminal p-6" dir={isHE ? "rtl" : "ltr"}>
      <div className="mx-auto max-w-3xl">
        <h1
          className="text-2xl font-bold mb-2"
          style={{ color: "#F88158" }}
        >
          {isHE ? "ביג בורד ומוקים" : "Big Board & Mock Drafts"}
        </h1>
        <p className="text-sm text-gray-300 mb-8">
          {isHE
            ? "מקבץ הדירוגים והמוק דראפטים של Hoops-BG."
            : "Hoops-BG's own board and mock drafts."}
        </p>

        <div className="grid gap-4 sm:grid-cols-2">
          {/* Big Board — still a placeholder */}
          <div
            aria-disabled="true"
            className={`${cardClass} cursor-not-allowed opacity-60`}
          >
            <span className="text-lg font-semibold text-gray-100">
              {isHE ? "ביג בורד של Hoops-BG" : "Hoops-BG Big Board"}
            </span>
            <span className="mt-3 inline-flex w-fit items-center rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-gray-300">
              {isHE ? "בקרוב" : "upcoming"}
            </span>
          </div>

          {/* Collective Mock Draft — active */}
          <Link
            to="/collective-mock-draft"
            className={`${cardClass} transition hover:bg-[#1E222A] hover:ring-white/15 active:scale-[0.99]`}
          >
            <span className="text-lg font-semibold text-gray-100 transition group-hover:text-white">
              {isHE ? "מוק דראפט קולקטיבי של Hoops-BG" : "Hoops-BG Collective Mock Draft"}
            </span>
            <span
              className="mt-3 inline-flex w-fit items-center rounded-full px-3 py-1 text-xs font-medium text-white"
              style={{ backgroundColor: "#F88158" }}
            >
              {isHE ? "צפו במוק" : "view mock"}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BigBoardMocksPage;
